enum HeaderStyle {
  CAPACITY = 'capacity',
  LOUNGE_CLOSED = 'lounge closed',
  MAX_PERIOD = 'max period',
  MIN_PERIOD = 'min period',
  NO_FLIGHT = 'no flight',
  SERVER = 'server',
  UNKNOWN = 'unknown',
}

enum FooterStyle {
  CAPACITY = 'CAPACITY',
  FLIGHT_INFO_NOT_FOUND = 'FLIGHT_INFO_NOT_FOUND',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  LOUNGE_CLOSED = 'LOUNGE_CLOSED',
  MAX_PERIOD = 'MAX_PERIOD',
  MIN_PERIOD = 'MIN_PERIOD',
}

export { FooterStyle, HeaderStyle };
